import React from 'react';
import type { GridReadyEvent, SortChangedEvent } from 'ag-grid-community';

import Flash from '../../Flash/Flash';
import GadgetLoadError from '../../GadgetLoadError';
import Grid from '../../Grid/Grid';
import IncompatibleComparison from '../../IncompatibleComparison';
import { CardSkeleton } from '../../Skeleton';
import MetricMatrixContext from '../../../contexts/MetricMatrixContext';
import ShowAll from './ShowAll';
import SingleMetricMatrixContext from '../../../contexts/SingleMetricMatrixContext';
import Typography from 'kingpin/atoms/Typography';

const SingleMetricDateMatrixView = ({
  isCompatibleComparison,
  isInitialLoading,
  isError,
  gridOptions,
  colDefs,
  totalsRowData,
  visId,
  onDrillDown,
  onGridReady,
  onColumnSort,
  isFlashVisible,
  onFlashDismissed,
  currentItems,
  autoSizeFirstColumnOnly,
  singleMetricMatrixContextValue,
}: {
  isCompatibleComparison: boolean | undefined;
  isInitialLoading: boolean;
  isError: boolean;
  gridOptions: any;
  colDefs: any[];
  totalsRowData: any;
  visId: string;
  onDrillDown: (term: string, ctrlKey?: boolean) => void;
  onGridReady: (event: GridReadyEvent) => void;
  onColumnSort: (event: SortChangedEvent) => void;
  isFlashVisible: boolean;
  onFlashDismissed: () => void;
  currentItems: number;
  autoSizeFirstColumnOnly: boolean;
  singleMetricMatrixContextValue: React.ComponentProps<
    typeof SingleMetricMatrixContext.Provider
  >['value'];
}) => {
  if (!isCompatibleComparison) {
    return <IncompatibleComparison />;
  }

  if (isError) {
    return <GadgetLoadError />;
  }

  if (isInitialLoading) {
    return <CardSkeleton />;
  }

  return (
    <MetricMatrixContext.Provider value={{ onDrillDown }}>
      <SingleMetricMatrixContext.Provider
        value={singleMetricMatrixContextValue}
      >
        <ShowAll />
        <div style={{ position: 'absolute', width: '100%' }}>
          <Flash
            type="info"
            isVisible={isFlashVisible}
            onDismissed={onFlashDismissed}
            messageHtml={
              <div>
                <Typography.Body
                  type="Body 12"
                  color={'white'}
                >{`Only sorting the ${currentItems} currently displayed`}</Typography.Body>
                <br />
                <Typography.Body type="Body 12">
                  {"Click 'Load All' and then sort to sort all items"}
                </Typography.Body>
              </div>
            }
          />
        </div>
        <Grid
          columnDefs={colDefs}
          onGridReady={onGridReady}
          gridOptions={gridOptions}
          totalsRow={totalsRowData}
          gridId={visId}
          onSortChanged={onColumnSort}
          autoSizeFirstColumnOnly={autoSizeFirstColumnOnly}
          layoutOnFirstRender={true}
          layoutOnColumnChange={true}
          layoutOnModelUpdated={true}
          hasBorders={false}
          hasDarkHeader={false}
          enableHeadlessRefit
        />
      </SingleMetricMatrixContext.Provider>
    </MetricMatrixContext.Provider>
  );
};

export default SingleMetricDateMatrixView;
